import type { VoidFunctionComponent } from 'react';
import CallToAction from '../../../../../../CallToAction';
import styles from '../../../shared/ReleaseGroupsRevamp.module.less';

type Props = {
  titleText: string;
};

/**
 * ReleaseGroupsCTA loads NavBar content for the containers used in the Release Groups revamp.
 * Note that some containers in the revamp inherit and use the older NavigationStore approach
 * from shared components defined by their routes, and will not use this component.
 */
const ReleaseGroupsCTA: VoidFunctionComponent<Props> = ({ titleText }) => (
  <CallToAction noPadding>
    <div className={styles.cta}>
      <div className={styles.label}>RELEASE GROUPS</div>
      <div className={styles.title}>{titleText}</div>
    </div>
  </CallToAction>
);

export default ReleaseGroupsCTA;
